import { FC, MouseEventHandler, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { AccessControl } from "@ryde/controls";
import {
  DrawerType,
  RideCrudModeKey,
  RydeUiUnit,
  useDrawers,
  useIsMobile,
} from "@ryde/shared";

import { ButtonHeader } from "./button-header.styled";

interface ILayoutRightHistoryButton {
  entity: RydeUiUnit;
  dtoId: number | undefined;
}

export const LayoutRightHistoryButton: FC<ILayoutRightHistoryButton> = ({
  entity,
  dtoId,
}) => {
  const { isMobile } = useIsMobile();
  const { openDrawer } = useDrawers();
  const { t } = useTranslation();

  const onHistoryClick: MouseEventHandler<HTMLButtonElement> = (e): void => {
    e.preventDefault();

    if (!dtoId) {
      return;
    }

    if (entity === RideCrudModeKey.uiUnit) {
      openDrawer({
        drawerProps: {
          type: DrawerType.RideHistoryLog,
          entity: entity,
          id: dtoId,
        },
      });
    } else {
      openDrawer({
        drawerProps: {
          type: DrawerType.HistoryLog,
          entity: entity,
          id: dtoId,
        },
      });
    }
  };

  const isHistoryButtonVisible = useMemo(() => {
    return !isMobile && entity && entity !== "unknown" && Boolean(dtoId);
  }, [dtoId, entity, isMobile]);
  return (
    isHistoryButtonVisible && (
      <AccessControl entity="auditLog" action="read">
        <ButtonHeader className="DrawerHeader-History" onClick={onHistoryClick}>
          <SVG_MUI.History2SVG data-e2e="layout-right-history-button-svg" />
          <span>{t(`general.HISTORY`)}</span>
        </ButtonHeader>
      </AccessControl>
    )
  );
};
